import { Outlet, Link } from 'react-router-dom'
import styles from './Layout.module.css'

export default function Layout() {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <Link to="/" className={styles.logo}>
            Osi-Use
          </Link>
          <nav className={styles.nav}>
            <Link to="/search">検索</Link>
            <Link to="/collection">コレクション</Link>
            <Link to="/mypage">マイページ</Link>
          </nav>
        </div>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>

      <footer className={styles.footer}>
        <p>&copy; 2025 Osi-Use</p>
      </footer>
    </div>
  )
}
